import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Segmentation.svg",
  "use": "Segmentation.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Segmentation.svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 5.74744C17 5.42798 17.3561 5.23743 17.6219 5.41467L22.2512 8.50086C22.6074 8.73828 22.6074 9.26184 22.2512 9.49927L17.6219 12.5855C17.3561 12.7627 17 12.5721 17 12.2527V10H0V8H17V5.74744Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol